import { loadingReducer } from '../loading/reducer';
import { POLL_PURCHASE_STATUS_FAILURE, POLL_PURCHASE_STATUS_REQUEST, POLL_PURCHASE_STATUS_SUCCESS, SET_PURCHASE } from '../gateway/actions';
import { MANA_FIAT_GATEWAY_PURCHASE_COMPLETED_FAILURE, OPEN_BUY_MANA_WITH_FIAT_MODAL_FAILURE, OPEN_BUY_MANA_WITH_FIAT_MODAL_REQUEST, OPEN_BUY_MANA_WITH_FIAT_MODAL_SUCCESS, OPEN_MANA_FIAT_GATEWAY_FAILURE, OPEN_MANA_FIAT_GATEWAY_REQUEST, OPEN_MANA_FIAT_GATEWAY_SUCCESS } from './actions';
export const INITIAL_STATE = {
    data: { purchases: [] },
    loading: [],
    error: null
};
export function gatewayReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case OPEN_BUY_MANA_WITH_FIAT_MODAL_REQUEST: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: null
            };
        }
        case OPEN_BUY_MANA_WITH_FIAT_MODAL_SUCCESS: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action)
            };
        }
        case OPEN_BUY_MANA_WITH_FIAT_MODAL_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error
            };
        }
        case OPEN_MANA_FIAT_GATEWAY_REQUEST: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: null
            };
        }
        case OPEN_MANA_FIAT_GATEWAY_SUCCESS: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action)
            };
        }
        case OPEN_MANA_FIAT_GATEWAY_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error
            };
        }
        case MANA_FIAT_GATEWAY_PURCHASE_COMPLETED_FAILURE: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: action.payload.error
            };
        }
        case SET_PURCHASE: {
            const { purchase } = action.payload;
            return {
                ...state,
                data: {
                    ...state.data,
                    purchases: [
                        ...state.data.purchases.filter(_purchase => _purchase.id !== purchase.id),
                        purchase
                    ]
                }
            };
        }
        case POLL_PURCHASE_STATUS_REQUEST: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error: null
            };
        }
        case POLL_PURCHASE_STATUS_SUCCESS: {
            return {
                ...state,
                loading: loadingReducer(state.loading, action)
            };
        }
        case POLL_PURCHASE_STATUS_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                loading: loadingReducer(state.loading, action),
                error
            };
        }
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map